export default "__VITE_ASSET__Dh2_CTFJ__"